import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import ReferralItem from "./ReferralItem";
import InviteButton from "../Buttons/InviteButton";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import {initNotification} from "../../store/notificationSlice";
import {fetchReferrals} from "../../store/referralsSlice";
import Loader from "../Loader";

const Body = () => {
    const [loading, setLoading] = useState(true);
    const dispatch = useAppDispatch();
    const {data: referralsData, status: referralsStatus, error: referralsError} = useAppSelector((state) => state.referrals)

    useEffect(() => {
        switch (referralsStatus) {
            case 'idle':
                dispatch(fetchReferrals())
                break;
            case 'fulfilled':
                setLoading(false);
                break;
            case 'rejected':
                dispatch(initNotification({data: {message: referralsError, type:'error',show: true}}))
                break;
        }
    }, [dispatch, referralsError, referralsStatus]);

    return (
        <Container>
            <UlWrapper>
            <Loader loading={loading} duration={300}>
                    <Ul>
                        {referralsData && referralsData.map(referral => <Li key={referral.id}><ReferralItem referral={referral}/></Li>)}
                    </Ul>
                </Loader>
            </UlWrapper>
            <ButtonWrapper>
                <InviteButton/>
            </ButtonWrapper>
        </Container>
    );
};

export default Body;

const Container = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
const UlWrapper = styled.div`
    height: 100%;
    overflow-y: scroll;
`;
const Ul = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;
const Li = styled.li`
    padding: 16px 24px;
    border-bottom: 2px solid #2F2F2F;
`;
const ButtonWrapper = styled.div`
    height: 74px;
    display: flex;
    align-items: center;
    padding: 0 24px;
`;
